const PARTNERS = [
  "Farrow & Ball", "Vola", "Ressource", "Argile", "THG Paris",
  "Dornbracht", "Carrelages du Marais", "Hervé Gambs", "Lutron", "Bisazza",
];

export default function Marquee() {
  return (
    <div data-testid="marquee" className="border-y border-ink/15 bg-bone py-6 overflow-hidden marquee-mask">
      <div className="flex gap-16 animate-marquee whitespace-nowrap">
        {[...PARTNERS, ...PARTNERS].map((p, i) => (
          <span key={i} className="font-display text-3xl md:text-4xl text-ink/40 italic">
            {p} <span className="not-italic text-terracotta">·</span>
          </span>
        ))}
      </div>
    </div>
  );
}
